
export function make(tagName, classNames = null, attributes = {}) {
  const el = document.createElement(tagName);

  if (Array.isArray(classNames)) {
	let trimmed = classNames.map(c => { if (c) return c.trim() });
	el.classList.add(...trimmed);
  } else if (classNames) {
	let splitted = classNames.trim().split(/\s+/);
	el.classList.add(...splitted);
  }

  for (const attributeName in attributes) {
	switch (attributeName) {
	  case 'innerText':
	  case 'innerHTML':
		el[attributeName] = attributes[attributeName];
		break
	  default:
		el.setAttribute(attributeName, attributes[attributeName]);
		break;
	}
  }

  return el;
};

export function executeFunctionByName(functionName, context) {
  var args = Array.prototype.slice.call(arguments, 2);
  var namespaces = functionName.split(".");
  var func = namespaces.pop();
  for (var i = 0; i < namespaces.length; i++) {
	context = context[namespaces[i]];
  }
  return context[func].apply(context, args);
}

export function debounce(func, delay = 300) {
  let timer;
  return (...args) => {
	clearTimeout(timer);
	timer = setTimeout(() => { func.apply(this, args); }, delay);
  }
}

export function copyToClipboard(input) {
  input.select();
  input.setSelectionRange(0, 99999); // For mobile devices
  navigator.clipboard.writeText(input.value);
}